import { render, staticRenderFns } from "./ymShouye.vue?vue&type=template&id=a98c6310"
import script from "./ymShouye.vue?vue&type=script&lang=js"
export * from "./ymShouye.vue?vue&type=script&lang=js"
import style0 from "./ymShouye.vue?vue&type=style&index=0&id=a98c6310&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports